module.exports = __webpack_public_path__ + "img/Figure1.500cc30b.png";